import {Input, Textarea} from '@mantine/core';
import {renderFieldLabel} from 'src/app/forms/renderFieldLabel';
import React, {useId} from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';

export interface FormTextAreaV2Props {
  field: IFormFieldV2;
  value: string;
  error?: string;
  onChange: (name: string, value: string) => void;
}

export const FormTextAreaV2 = React.memo<FormTextAreaV2Props>(
  ({field, value, error, onChange}: FormTextAreaV2Props) => {
    const inputId = useId();
    return (
      <Input.Wrapper
        id={inputId}
        data-testid={`form-field-${field.name}`}
        label={renderFieldLabel(field)}
        error={error}
        description={field.description}
        withAsterisk={field.required}>
        <Textarea
          id={inputId}
          data-testid={`form-field-${field.name}-input`}
          value={value || ''}
          onChange={e => onChange(field.name, e.currentTarget.value)}
          placeholder={field.placeholder ?? `Enter ${field.label.toLowerCase()}`}
          error={!!error}
          autosize={true}
          minRows={field.textboxOptions?.minRows ?? 4}
          disabled={field.disabled}
        />
      </Input.Wrapper>
    );
  }
);
